import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'OpenJobsInformation',
    templateUrl: './OpenJobsInformation.html'
})

export class OpenJobsInformation extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    ModalRef: NgbModalRef;
    Model: any;
    DisableModalOpenEvent: boolean = false;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {

    }

    Open(Data: any): void {
        if (this.DisableModalOpenEvent) return;
        this.Model = '';
        if (Data.length > 0) {
            for (let i=0; i < Data.length; i++) {
                this.Model += this.masterService.LoggedInUserData.Properties.find(a => a.PropertyId == Data[i]).PropertyCode;
                if (i != Data.length - 1)
                    this.Model += ', ';
            }
        }
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        this.DisableModalOpenEvent = true;
        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }
}
